import request from '../../request';

export default {
  state: {
    showSaveSuccessMessage: false,
    showUndoDeleteMessage: false,
    lastDeleted: null,
    imageUploadUrl: '',
    gotDataFromServer: false,
    gotListFromServer: false,
    list: [],
    single: {},
    formValid: undefined,
    formSaved: undefined,
    durationDays: '',
    durationHours: '',
    durationMinutes: '',
    selectedCategoriesHolder: [],
    formActivityId: undefined,
    cannotDelete: false,
    visibleCategories: [],

    selectedRegion: null,
    selectedDistrict: null,
    selectedMunicipality: null,
    selectedRivers: false,
    selectedMountains: false,
    selectedProtectedAreas: false,
    selectedOtherLocations: false,
    location: { // Only used for errors
      touched: false,
      errors: [],
    },
    form: {
      duration: {
        name: 'duration',
        value: undefined,
        label: 'Duration',
        icon: 'fa-clock-o',
        errors: [],
      },
      allowsInstantBooking: {
        name: 'allows_instant_booking',
        // value: false,
        label: 'Allow Instant Booking',
        options: [
          {
            value: 1,
            checked: false,
            label: 'Allow instant booking',
          },
        ],
        errors: [],
      },
      categories: {
        name: 'categories',
        value: undefined,
        label: 'Categories',
        options: [],
        errors: [],
      },
      basePrice: {
        name: 'base_price',
        label: 'Base Price',
        value: 0.00,
        icon: '',
        errors: [],
      },
      cancelationDays: {
        name: 'cancelation_days',
        label: '',
        value: '',
        icon: '',
        errors: [],
      },
      minimumAge: {
        name: 'minimum_age',
        label: 'Minimum Age',
        value: '0',
        icon: '',
        errors: [],
      },
      youthAge: {
        name: 'youth_age',
        label: 'Youth Discount (age)',
        value: '0',
        icon: '',
        errors: [],
      },
      groupMin: {
        name: 'group_min',
        value: 1,
        icon: '',
        errors: [],
      },
      groupMax: {
        name: 'group_max',
        value: 1,
        icon: '',
        errors: [],
      },
      hasYouthAge: {
        options: [
          {
            value: 1,
            checked: false,
            label: 'Yes',
          },
        ],
        errors: [],
      },
      isNatureTourism: {
        options: [
          {
            value: 1,
            checked: false,
            label: 'Is recognized as a Nature Tourism activity',
          },
        ],
        errors: [],
      },
      isLowMobilityAccessible: {
        options: [
          {
            value: 1,
            checked: false,
            label: 'Is low mobility accessible',
          },
        ],
        errors: [],
      },
      address1: {
        name: 'address_1',
        label: 'Address',
        value: undefined,
        icon: '',
        errors: [],
      },
      address2: {
        name: 'address_2',
        label: '',
        value: undefined,
        icon: '',
        errors: [],
      },
      city: {
        name: 'city',
        label: 'City',
        value: undefined,
        icon: '',
        errors: [],
      },
      latitude: {
        name: 'latitude',
        label: 'Latitude',
        value: 39,
        icon: '',
        errors: [],
      },
      longitude: {
        name: 'longitude',
        label: 'Longitude',
        value: -8,
        icon: '',
        errors: [],
      },
      isPricedPerOccurrence: {
        name: 'is_priced_per_occurrence',
        label: 'Is priced per Occurrence',
        value: 0,
        errors: [],
      },
      localePtName: {
        name: 'locale.pt.name',
        label: 'Name',
        value: undefined,
        icon: '',
        errors: [],
      },
      localeEnName: {
        name: 'locale.en.name',
        label: 'Name',
        value: undefined,
        icon: '',
        errors: [],
      },
      localePtDescription: {
        name: 'locale.pt.description',
        label: 'Description',
        value: undefined,
        icon: '',
        errors: [],
      },
      localeEnDescription: {
        name: 'locale.en.description',
        label: 'Description',
        value: undefined,
        icon: '',
        errors: [],
      },
      localePtIncluded: {
        name: 'locale.pt.included',
        label: 'What\'s Included',
        value: undefined,
        icon: '',
        errors: [],
      },
      localeEnIncluded: {
        name: 'locale.en.included',
        label: 'What\'s Included',
        value: undefined,
        icon: '',
        errors: [],
      },
      localePtDoNotForget: {
        name: 'locale.pt.do_not_forget',
        label: 'Don\'t Forget',
        value: undefined,
        icon: '',
        errors: [],
      },
      localeEnDoNotForget: {
        name: 'locale.en.do_not_forget',
        label: 'Don\'t Forget',
        value: undefined,
        icon: '',
        errors: [],
      },
      localePtAditionalInfoQuestion: {
        name: 'locale.pt.aditional_info_question',
        label: 'Aditional info question',
        value: undefined,
        icon: '',
        errors: [],
      },
      localeEnAditionalInfoQuestion: {
        name: 'locale.en.aditional_info_question',
        label: 'Aditional Info question',
        value: undefined,
        icon: '',
        errors: [],
      },
      localePtAditionalServices: {
        name: 'locale.pt.aditional_services',
        label: 'Aditional Services',
        value: undefined,
        icon: '',
        errors: [],
      },
      localeEnAditionalServices: {
        name: 'locale.en.aditional_services',
        label: 'Aditional Services',
        value: undefined,
        icon: '',
        errors: [],
      },
      localePtSpokenLanguages: {
        name: 'locale.pt.spoken_languages',
        value: undefined,
        icon: '',
        errors: [],
      },
      localeEnSpokenLanguages: {
        name: 'locale.en.spoken_languages',
        value: undefined,
        icon: '',
        errors: [],
      },
    },
  },
  mutations: {
    removeUndoDeleteMessage(state) {
      Object.assign(state, { showUndoDeleteMessage: false });
    },
    setAddActivityForm(state, payload) {
      if (payload.key !== 'allowsInstantBooking' &&
        payload.key !== 'isNatureTourism' &&
        payload.key !== 'hasYouthAge' &&
        payload.key !== 'isLowMobilityAccessible'
      ) {
        Object.assign(state.form[payload.key], { value: payload.value });
      } else {
        Object.assign(state.form[payload.key], { options: payload.value });
      }
    },
    setAddActivityDuration(state, payload) {
      if (payload.type === 'days') {
        Object.assign(state, { durationDays: payload.value });
      } else if (payload.type === 'hours') {
        Object.assign(state, { durationHours: payload.value });
      } else if (payload.type === 'minutes') {
        Object.assign(state, { durationMinutes: payload.value });
      }

      let min = parseInt(state.durationMinutes, 10);
      if (isNaN(min)) min = 0;
      let hours = parseInt(state.durationHours, 10);
      if (isNaN(hours)) hours = 0;
      let days = parseInt(state.durationDays, 10);
      if (isNaN(days)) days = 0;
      const duration = min + (hours * 60) + (days * 24 * 60);
      Object.assign(state.form.duration, { value: duration });
    },
    setAddActivityValidationErrors(state, payload) {
      const formKeys = Object.keys(state.form);
      formKeys.forEach((key) => {
        Object.assign(state.form[key], { errors: [] });
      });
      if (typeof payload['locale.pt.name'] !== 'undefined') {
        Object.assign(state.form.localePtName, { errors: payload['locale.pt.name'] });
      }
      if (typeof payload['locale.en.name'] !== 'undefined') {
        Object.assign(state.form.localeEnName, { errors: payload['locale.en.name'] });
      }
      if (typeof payload['locale.pt.description'] !== 'undefined') {
        Object.assign(state.form.localePtDescription, { errors: payload['locale.pt.description'] });
      }
      if (typeof payload['locale.en.description'] !== 'undefined') {
        Object.assign(state.form.localeEnDescription, { errors: payload['locale.en.description'] });
      }
      if (typeof payload['locale.pt.spoken_languages'] !== 'undefined') {
        Object.assign(state.form.localePtSpokenLanguages, { errors: payload['locale.en.spoken_languages'] });
      }
      if (typeof payload['locale.en.spoken_languages'] !== 'undefined') {
        Object.assign(state.form.localeEnSpokenLanguages, { errors: payload['locale.en.spoken_languages'] });
      }
      if (typeof payload.minimum_age !== 'undefined') {
        Object.assign(state.form.minimumAge, { errors: payload.minimum_age });
      }
      if (typeof payload.duration !== 'undefined') {
        Object.assign(state.form.duration, { errors: payload.duration });
      }
      if (typeof payload.youth_age !== 'undefined') {
        Object.assign(state.form.youthAge, { errors: payload.youth_age });
      }
      if (typeof payload.base_price !== 'undefined') {
        Object.assign(state.form.basePrice, { errors: payload.base_price });
      }
      if (typeof payload.cancelation_days !== 'undefined') {
        Object.assign(state.form.cancelationDays, { errors: payload.cancelation_days });
      }
      if (typeof payload.address_1 !== 'undefined') {
        Object.assign(state.form.address1, { errors: payload.address_1 });
      }
      if (typeof payload.latitude !== 'undefined') {
        Object.assign(state.form.latitude, { errors: payload.latitude });
      }
      if (typeof payload.longitude !== 'undefined') {
        Object.assign(state.form.longitude, { errors: payload.longitude });
      }
      if (typeof payload.is_priced_per_occurrence !== 'undefined') {
        Object.assign(state.form.isPricedPerOccurrence,
          { errors: payload.is_priced_per_occurrence });
      }
      if (typeof payload.locations !== 'undefined') {
        Object.assign(state.location, { errors: payload.locations });
      } else {
        Object.assign(state.location, { errors: [] });
      }

      if (typeof payload.categories !== 'undefined') {
        Object.assign(state.form.categories, { errors: payload.categories });
      }
      if (typeof payload.group_min !== 'undefined') {
        Object.assign(state.form.groupMin, { errors: payload.group_min });
      }
      if (typeof payload.group_max !== 'undefined') {
        Object.assign(state.form.groupMax, { errors: payload.group_max });
      }
    },
    toggleAddActivityFormCategory(state, index) {
      const newVal = !state.form.categories.options[index].checked;
      Object.assign(state.form.categories.options[index], { checked: newVal });
    },
    changeCoords(state, pos) {
      Object.assign(state.form.latitude, { value: pos.latitude });
      Object.assign(state.form.longitude, { value: pos.longitude });
      setTimeout(() => {
        window.Materialize.updateTextFields();
      }, 0);
    },
    updatePromoterActivityList(state, activities) {
      Object.assign(state, { list: activities });
      if (activities.length === 0) {
        Object.assign(state, { list: [] });
      }
      Object.assign(state, { gotListFromServer: true });
    },
    updateActivity(state, activity) {
      Object.assign(state, { single: activity });
    },
    /*
    touchAll(state) {
      const formKeys = Object.keys(state.form);
      formKeys.forEach((key) => {
        Object.assign(state.form[key], { untouched: false });
      });
    },
    untouchAll(state) {
      const formKeys = Object.keys(state.form);
      formKeys.forEach((key) => {
        Object.assign(state.form[key], { untouched: true });
      });
    },
    */
    setFormSaved(state, status) {
      Object.assign(state, { formSaved: status });
    },
    clearFields(state) {
      Object.assign(state, { formActivityId: undefined });
      Object.assign(state, { formSaved: undefined });
      const formKeys = Object.keys(state.form);
      formKeys.forEach((key) => {
        Object.assign(state.form[key], { value: undefined, errors: [] });
        if (typeof state.form[key].options !== 'undefined') {
          state.form[key].options.forEach((key2) => {
            if (typeof state.form[key].options[key2] !== 'undefined') {
              Object.assign(state.form[key].options[key2].checked, false);
            }
          });
        }
      });
      Object.assign(state, { selectedRegion: null });
      Object.assign(state, { selectedDistrict: null });
      Object.assign(state, { selectedMunicipality: null });
      Object.assign(state, { selectedRivers: false });
      Object.assign(state, { selectedMountains: false });
      Object.assign(state, { selectedProtectedAreas: false });
      Object.assign(state, { selectedOtherLocations: false });

      Object.assign(state.form.allowsInstantBooking.options[0], { checked: false });
      Object.assign(state.form.cancelationDays, { value: '', errors: [] });
      Object.assign(state.form.latitude, { value: 0, errors: [] });
      Object.assign(state.form.longitude, { value: 0, errors: [] });
      Object.assign(state.form.isPricedPerOccurrence, { value: 0, errors: [] });
      Object.assign(state.form.groupMin, { value: 1, errors: [] });
      Object.assign(state.form.groupMax, { value: 1, errors: [] });
      Object.assign(state, { durationDays: 0 });
      Object.assign(state, { durationHours: 0 });
      Object.assign(state, { durationMinutes: 0 });
      state.form.categories.options.forEach((category, index) => {
        Object.assign(state.form.categories.options[index], { checked: false });
      });
    },
    setActivityCategories(state, categories) {
      const newCategories = [];
      categories.forEach((category) => {
        const groups = category.groups.data.map(g => g.id);
        newCategories.push({
          value: category.id,
          label: category.name,
          checked: false,
          name: category.name,
          groups,
        });
      });
      Object.assign(state.form.categories, { options: newCategories });
    },
    removeActivityImage(state, id) {
      const newImages = [];
      state.single.images.data.forEach((image) => {
        if (image.id !== id) {
          newImages.push(image);
        }
      });
      Object.assign(state.single.images, { data: newImages });
    },
    setDuration(state, payload) {
      Object.assign(state.form.duration, { value: payload });
      Object.assign(state.form.duration, { errors: [] });
    },
    setSaveSuccessMessage(state, payload) {
      Object.assign(state, { showSaveSuccessMessage: payload });
    },
    setImageUploadUrl(state, payload) {
      Object.assign(state, { imageUploadUrl: payload });
    },
    setActivityFormData(state, payload) {
      Object.assign(state, { formActivityId: payload.id });
      if (typeof payload.translations.pt !== 'undefined') {
        Object.assign(state.form.localePtName, { value: payload.translations.pt.name });
        Object.assign(state.form.localePtDescription,
          { value: payload.translations.pt.description });
        Object.assign(state.form.localePtSpokenLanguages, {
          value: payload.translations.pt.spoken_languages,
        });
        Object.assign(state.form.localePtIncluded, { value: payload.translations.pt.included });
        Object.assign(state.form.localePtDoNotForget, {
          value: payload.translations.pt.do_not_forget },
        );
        Object.assign(state.form.localePtAditionalInfoQuestion, {
          value: payload.translations.pt.aditional_info_question },
        );
        Object.assign(state.form.localePtAditionalServices, {
          value: payload.translations.pt.aditional_services },
        );
      }
      if (typeof payload.translations.en !== 'undefined') {
        Object.assign(state.form.localeEnName, { value: payload.translations.en.name });
        Object.assign(state.form.localeEnDescription,
          { value: payload.translations.en.description });
        Object.assign(state.form.localeEnIncluded, { value: payload.translations.en.included });
        Object.assign(state.form.localeEnSpokenLanguages, {
          value: payload.translations.en.spoken_languages,
        });
        Object.assign(state.form.localeEnDoNotForget,
          { value: payload.translations.en.do_not_forget },
        );
        Object.assign(state.form.localeEnAditionalInfoQuestion,
          { value: payload.translations.en.aditional_info_question },
        );
        Object.assign(state.form.localeEnAditionalServices,
          { value: payload.translations.en.aditional_services },
        );
      }
      Object.assign(state.form.minimumAge, { value: payload.minimum_age });
      Object.assign(state.form.youthAge, { value: payload.youth_age });
      if (payload.youth_age !== 0 && payload.youth_age !== null) {
        Object.assign(state.form.hasYouthAge.options[0], { checked: true });
      }
      const duration = window.moment.duration(payload.duration, 'minutes');
      Object.assign(state, { durationDays: Math.floor(duration.asDays()) });
      Object.assign(state, { durationHours: Math.floor(duration.hours()) });
      Object.assign(state, { durationMinutes: Math.floor(duration.minutes()) });
      Object.assign(state.form.duration, { value: payload.duration });
      Object.assign(state.form.allowsInstantBooking.options[0],
        { checked: payload.allows_instant_booking },
      );
      Object.assign(state.form.isNatureTourism.options[0],
        { checked: payload.is_nature_tourism },
      );
      Object.assign(state.form.isLowMobilityAccessible.options[0],
        { checked: payload.is_low_mobility_accessible },
      );
      Object.assign(state.form.basePrice, { value: payload.base_price });
      Object.assign(state.form.groupMin, { value: payload.group_min });
      Object.assign(state.form.groupMax, { value: payload.group_max });
      Object.assign(state.form.latitude, { value: payload.latitude });
      Object.assign(state.form.longitude, { value: payload.longitude });
      let isPricedPerOccurrence = payload.is_priced_per_occurrence;
      if (isPricedPerOccurrence === true) {
        isPricedPerOccurrence = '1';
      } else if (isPricedPerOccurrence === false) {
        isPricedPerOccurrence = '0';
      }
      Object.assign(state.form.isPricedPerOccurrence, { value: isPricedPerOccurrence });
      Object.assign(state.form.address1, { value: payload.address_1 });
      Object.assign(state.form.address2, { value: payload.address_2 });
      Object.assign(state.form.city, { value: payload.city });

      // Category list might not be loaded yet
      // Object.assign(state, { selectedCategoriesHolder: payload.category });
      payload.category.data.forEach((category) => {
        const index = state.form.categories.options.findIndex(
          stateCategory => category.id === stateCategory.value,
        );
        Object.assign(state.form.categories.options[index], { checked: true });
      });

      // Locations are loaded elsewhere
      Object.assign(state.form.cancelationDays, { value: payload.cancelation_days });
    },
    setActivityLocationsFormData(state, payload) {
      payload.locations.forEach((location) => {
        switch (payload.types[location.location_type_id]) {
          case 'Nuts 2':
            Object.assign(state, { selectedRegion: location.id });
            break;
          case 'District':
            Object.assign(state, { selectedDistrict: location.id });
            break;
          case 'Municipality':
            Object.assign(state, { selectedMunicipality: location.id });
            break;
          case 'River':
            Object.assign(state, { selectedRivers: location.id });
            break;
          case 'Mountain':
            Object.assign(state, { selectedMountains: location.id });
            break;
          case 'Protected Area':
            Object.assign(state, { selectedProtectedAreas: location.id });
            break;
          case 'Place':
            Object.assign(state, { selectedOtherLocations: location.id });
            break;
          default:
            break;
        }
      });
    },
    setCategories(state) {
      state.selectedCategoriesHolder.forEach((category) => {
        const id = category.id;
        const categoryIndex = state.form.categories.options.findIndex(c => c.value === id);
        if (categoryIndex !== -1) {
          Object.assign(state.form.categories.options[categoryIndex], { checked: true });
        }
      });
    },
    setAddActivityLocation(state, payload) {
      Object.assign(state.location, { touched: true });

      if (payload.type === 'region') {
        Object.assign(state, { selectedRegion: payload.value });
      }
      if (payload.type === 'district') {
        Object.assign(state, { selectedDistrict: payload.value });
        /* Object.assign(state, { selectedRegion: null });
        Object.assign(state, { selectedMunicipality: null });
        Object.assign(state, { selectedRivers: false });
        Object.assign(state, { selectedMountains: false });
        Object.assign(state, { selectedProtectedAreas: false });
        Object.assign(state, { selectedOtherLocations: false }); */
      }
      if (payload.type === 'municipality') {
        Object.assign(state, { selectedMunicipality: payload.value });
      }
      if (payload.type === 'river') {
        Object.assign(state, { selectedRivers: payload.value });
      }
      if (payload.type === 'mountain') {
        Object.assign(state, { selectedMountains: payload.value });
      }
      if (payload.type === 'protectedArea') {
        Object.assign(state, { selectedProtectedAreas: payload.value });
      }
      if (payload.type === 'otherLocation') {
        Object.assign(state, { selectedOtherLocations: payload.value });
      }
    },
    setVisibleCategory(state, payload) {
      if (payload.checked) {
        state.visibleCategories.push(payload.id);
      }
      if (!payload.checked) {
        const index = state.visibleCategories.indexOf(payload.id);
        if (index !== -1) {
          state.visibleCategories.splice(index, 1);
        }
        state.form.categories.options.forEach((category, catIndex) => {
          const isVisible = category.groups.some((catGroup) => {
            let exists = false;
            if (state.visibleCategories.indexOf(catGroup) !== -1) {
              exists = true;
            }
            return exists;
          });
          if (!isVisible) {
            Object.assign(state.form.categories.options[catIndex], { checked: false });
          }
        });
      }
    },
    promoterSetDeletedInfo(state, id) {
      Object.assign(state, { showUndoDeleteMessage: true, lastDeleted: id });
    },
    setCannotDelete(state, cannotDelete) {
      Object.assign(state, { cannotDelete });
    },
  },
  actions: {
    removeActivityImage(context, payload) {
      context.commit('removeActivityImage', payload);
      context.dispatch('getActivity', window.vue.$route.params.slug);
    },
    setAddActivityForm(context, payload) {
      context.commit('setAddActivityForm', payload);

      // context.dispatch('saveNewActivity', { validateOnly: true });
    },
    setAddActivityDuration(context, payload) {
      context.commit('setAddActivityDuration', payload);
    },
    setAddActivityFormLocation(context, payload) {
      context.commit('setAddActivityLocation', payload);
    },
    toggleAddActivityFormCategory(context, payload) {
      context.commit('toggleAddActivityFormCategory', payload);
    },
    newCoords(context, coords) {
      if (coords.context === 'addActivity') {
        context.commit('changeCoords', { latitude: coords.lat, longitude: coords.lng });
      }
    },
    getPromoterActivityList(context) {
      const promoter = context.rootState.promoter.data.id;
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}activity`,
        data: {
          promoter,
          withDrafts: true,
          unapproved: true,
        },
      }, (err, res) => {
        if (!err) {
          if (res.status === 200) {
            context.commit('updatePromoterActivityList', res.body.data);
          }
        }
        if (res.body.status_code === 404) {
          context.commit('updatePromoterActivityList', []);
        }
      });
    },
    setActivityVisibleCategory(context, payload) {
      context.commit('setVisibleCategory', { checked: payload.checked, id: payload.id });
    },
    getEditActivity(context, payload) {
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}activity/${payload}`,
        data: {},
      }, (err, res) => {
        if (res.status === 200) {
          if (typeof res.body.data !== 'undefined') {
            context.commit('setActivityFormData', res.body.data);
            if (res.body.data.locations !== 'undefined') {
              context.commit('setActivityLocationsFormData', {
                locations: res.body.data.locations.data,
                types: context.rootState.locations.typesById,
              });
            }
            setTimeout(() => {
              if (typeof window.Materialize !== 'undefined') {
                if (typeof window.Materialize.updateTextFields !== 'undefined') {
                  window.Materialize.updateTextFields();
                }
              }
            }, 500);
          }
        }
      });
    },
    getActivity(context, payload) {
      return new Promise((resolve) => {
        request.make({
          type: 'GET',
          url: `${process.env.API_URL}activity/${payload}`,
          data: {},
        }, (err, res) => {
          if (res.status === 200) {
            if (typeof res.body.data !== 'undefined') {
              context.commit('updateActivity', res.body.data);
              context.commit('setImageForm', res.body.data.images.data);
              resolve();
            }
          }
        });
      });
    },
    promoterDeleteActivity(context, id) {
      request.make({
        type: 'DELETE',
        url: `${process.env.API_URL}activity/${id}`,
        data: {},
      }, (err, res) => {
        if (res.status === 204) {
          context.dispatch('getPromoterActivityList');
          context.commit('promoterSetDeletedInfo', id);
        }
        if (res.status === 422) {
          context.commit('setCannotDelete', true);
        }
      });
    },
    promoterCannotDeleteActivity(context, val) {
      context.commit('setCannotDelete', val);
    },
    promoterDismissUndoMessage(context) {
      context.commit('removeUndoDeleteMessage');
    },
    promoterUndoDeleteActivity(context) {
      request.make({
        type: 'PATCH',
        url: `${process.env.API_URL}activity/`,
        data: { id: context.state.lastDeleted, delete: false },
      }, (err, res) => {
        if (res.statusCode === 204) {
          context.commit('removeUndoDeleteMessage');
          context.dispatch('getPromoterActivityList');
        }
      });
    },
    saveNewActivity(context, payload) {
      // context.commit('touchAll');
      const selectedCategories = [];
      context.state.form.categories.options.forEach((category) => {
        if (category.checked === true) {
          selectedCategories.push(category.value);
        }
      });
      let duration = parseInt(context.state.form.duration.value, 10);
      if (isNaN(duration)) duration = 0;
      let minimumAge = parseInt(context.state.form.minimumAge.value, 10);
      if (isNaN(minimumAge)) minimumAge = 0;
      let youthAge = null;
      if (context.state.form.youthAge.value !== null) {
        youthAge = parseInt(context.state.form.youthAge.value, 10);
      }
      if (isNaN(youthAge) && youthAge !== null) youthAge = 0;
      const locations = [];
      if (context.state.selectedDistrict !== null) {
        locations.push(context.state.selectedDistrict);
      }

      if (context.state.selectedMunicipality != null) {
        locations.push(context.state.selectedMunicipality);
      }
      if (context.state.selectedRegion != null) {
        locations.push(context.state.selectedRegion);
      }

      if (context.state.selectedRivers) {
        locations.push(context.state.selectedRivers);
      }
      if (context.state.selectedMountains) {
        locations.push(context.state.selectedMountains);
      }
      if (context.state.selectedProtectedAreas) {
        locations.push(context.state.selectedProtectedAreas);
      }
      if (context.state.selectedOtherLocations) {
        locations.push(context.state.selectedOtherLocations);
      }
      const data = {
        promoter_id: context.rootState.promoter.data.id,
        duration,
        allows_instant_booking: context.state.form.allowsInstantBooking.options[0].checked,
        is_nature_tourism: context.state.form.isNatureTourism.options[0].checked,
        is_low_mobility_accessible: context.state.form.isLowMobilityAccessible.options[0].checked,
        minimum_age: minimumAge,
        youth_age: youthAge,
        base_price: parseFloat(context.state.form.basePrice.value),
        is_priced_per_occurrence: context.state.form.isPricedPerOccurrence.value === '1',
        cancelation_days: parseInt(context.state.form.cancelationDays.value, 10),
        group_min: parseInt(context.state.form.groupMin.value, 10),
        group_max: parseInt(context.state.form.groupMax.value, 10),
        address_1: context.state.form.address1.value,
        address_2: context.state.form.address2.value,
        city: context.state.form.city.value,
        categories: selectedCategories,
        latitude: parseFloat(context.state.form.latitude.value),
        longitude: parseFloat(context.state.form.longitude.value),
        locations,
        locale: {
          pt: {
            name: context.state.form.localePtName.value,
            description: context.state.form.localePtDescription.value,
            included: context.state.form.localePtIncluded.value,
            do_not_forget: context.state.form.localePtDoNotForget.value,
            aditional_info_question: context.state.form.localePtAditionalInfoQuestion.value,
            aditional_services: context.state.form.localePtAditionalServices.value,
            spoken_languages: context.state.form.localePtSpokenLanguages.value,
          },
          en: {
            name: context.state.form.localeEnName.value,
            description: context.state.form.localeEnDescription.value,
            included: context.state.form.localeEnIncluded.value,
            do_not_forget: context.state.form.localeEnDoNotForget.value,
            aditional_info_question: context.state.form.localeEnAditionalInfoQuestion.value,
            aditional_services: context.state.form.localeEnAditionalServices.value,
            spoken_languages: context.state.form.localeEnSpokenLanguages.value,
          },
        },
      };
      if (!data.group_min) data.group_min = 0;
      // if (isNaN(data.group_min);
      if (!data.group_max) data.group_max = 0;

      let validateOnly = false;
      if (typeof payload !== 'undefined') {
        if (typeof payload.validateOnly !== 'undefined') {
          if (payload.validateOnly) {
            validateOnly = true;
            data.validateOnly = true;
          }
        }
      }
      let type = 'POST';
      if (typeof context.state.formActivityId !== 'undefined') {
        data.id = context.state.formActivityId;
        type = 'PUT';
      }
      request.make({
        type,
        url: `${process.env.API_URL}activity`,
        data,
      }, (err, res) => {
        if (res.status === 201 || res.status === 204) {
          if (!validateOnly) {
            let url = `/${context.rootState.language}/supplier/activities`;
            if (typeof res.headers.location !== 'undefined') {
              if (payload.goto === 'activityPhotos') {
                const location = res.headers.location.split('/').pop();
                url = `/${context.rootState.language}/supplier/activities/${location}/images`;
              }
            }
            setTimeout(() => {
              window.vue.$router.push(url);
            }, 1500);
            context.commit('setSaveSuccessMessage', true);
            Object.assign(context.state, { formSaved: true });
            // context.commit('untouchAll');
          }
        } else if (res.status === 422) {
          if (typeof res.body.errors !== 'undefined') {
            context.commit('setAddActivityValidationErrors', res.body.errors);
          }
          if (!validateOnly) {
            Object.assign(context.state, { formSaved: false });
            context.dispatch('showSaveError');
          }
        }
      });
    },
    setActivitySaveSuccesMessage(context, payload) {
      context.commit('setSaveSuccessMessage', payload);
    },
    setActivityCategoryValues(context) {
      context.commit('setCategories');
    },
    addActivitySetDuration(context, payload) {
      context.commit('setDuration', payload);
    },
    clearFields(context) {
      // context.commit('untouchAll');
      context.commit('clearFields');
      context.commit('setFormSaved', undefined);
    },
    resetFormSaved(context) {
      context.commit('setFormSaved', undefined);
    },
    setActivityCategories(context, payload) {
      context.commit('setActivityCategories', payload);
    },
  },
  getters: {

  },
};



// WEBPACK FOOTER //
// ./src/store/promoter/activity.js